module.exports = __webpack_public_path__ + "media/images/Completed-pana-150d009ee99d634c3e46266f0dc4b40b.png";